// extracted by mini-css-extract-plugin
export default {"messageBlock":"_2-38","messageContainer":"Erap","textAndAvatar":"H0Y_","textAndAvatarReverse":"_3Lcn","opponentExtraMargin":"_22ma","spacer":"_1Y3d"};